import { render, staticRenderFns } from "./UnifiedRoulette.vue?vue&type=template&id=2b251a21&scoped=true&"
import script from "./UnifiedRoulette.vue?vue&type=script&lang=js&"
export * from "./UnifiedRoulette.vue?vue&type=script&lang=js&"
import style0 from "./UnifiedRoulette.vue?vue&type=style&index=0&id=2b251a21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b251a21",
  null
  
)

export default component.exports